module.exports = __webpack_public_path__ + "static/media/dialog-close.0e9b4067.svg";